import { ContentContainersCollection } from 'src/graphql/queries/GetFlexibleContentHub';
import {
  BenefitsContainer,
  FaqContainer,
  MarketingContentBlock,
  OrVideo,
  Resource,
  SocialProof,
  Statistic,
} from 'src/graphql/generated/graphql';

interface ContentContainers {
  benefitsContainer: BenefitsContainer;
  statistic: Statistic;
  getCertifiedSection: MarketingContentBlock;
  earnACertificateSection: MarketingContentBlock;
  certifiedAssociateSection: MarketingContentBlock;
  credentialHolderSection: MarketingContentBlock;
  certifiedProfessionalSection: MarketingContentBlock;
  video: OrVideo;
  socialProof: SocialProof;
  readyGetStartedSection: MarketingContentBlock;
  resource: Resource;
  faq: FaqContainer;
}

export const getContentContainers = (collection: ContentContainersCollection): ContentContainers => {
  const benefitsContainer = collection.find((item) => item.__typename === 'BenefitsContainer') as
    | BenefitsContainer
    | undefined as BenefitsContainer;
  const statistic = collection.find((item) => item.__typename === 'Statistic') as Statistic | undefined as Statistic;
  const getCertifiedSection = collection.find(
    (item) => item.__typename === 'MarketingContentBlock' && item.titleExternal === 'Get certified',
  ) as MarketingContentBlock;
  const earnACertificateSection = collection.find(
    (item) => item.__typename === 'MarketingContentBlock' && item.titleExternal === 'Earn a certificate',
  ) as MarketingContentBlock;
  const certifiedAssociateSection = collection.find(
    (item) => item.__typename === 'MarketingContentBlock' && item.titleExternal === 'Atlassian Certified Associate',
  ) as MarketingContentBlock;
  const credentialHolderSection = collection.find(
    (item) => item.__typename === 'MarketingContentBlock' && item.titleExternal === 'Atlassian Certificate Holder',
  ) as MarketingContentBlock;
  const certifiedProfessionalSection = collection.find(
    (item) => item.__typename === 'MarketingContentBlock' && item.titleExternal === 'Atlassian Certified Professional',
  ) as MarketingContentBlock;
  const video = collection.find((item) => item.__typename === 'OrVideo') as OrVideo | undefined as OrVideo;
  const socialProof = collection.find((item) => item.__typename === 'SocialProof') as
    | SocialProof
    | undefined as SocialProof;
  const readyGetStartedSection = collection.find(
    (item) => item.__typename === 'MarketingContentBlock' && item.titleExternal === 'Ready to get started?',
  ) as MarketingContentBlock;
  const resource = collection.find((item) => item.__typename === 'Resource') as Resource;
  const faq = collection.find((item) => item.__typename === 'FaqContainer') as FaqContainer | undefined as FaqContainer;

  return {
    benefitsContainer,
    statistic,
    getCertifiedSection,
    earnACertificateSection,
    certifiedAssociateSection,
    credentialHolderSection,
    certifiedProfessionalSection,
    video,
    socialProof,
    readyGetStartedSection,
    resource,
    faq,
  };
};

export const getCertificationTypeLabels = (title: string): string => {
  if (title.toLowerCase().includes('certificate')) {
    return 'Certificates';
  }
  const words = title.split(' ');
  const label = words[words.length - 1];

  return label + ' certifications';
};
